import React, {Children, cloneElement, Component, ReactElement, ReactNode, useEffect, useRef, useState} from "react";
import cx from "classnames";
import {Button, MediaCenterBox} from "@varymadellc/my-weed-club-component-library";
import {IoClose} from "react-icons/io5";

export interface QueueHeadDisplayProps {
    children: ReactElement | ReactElement[];
    itemRotateBySeconds?: number;
    className?: string;
    hide?: boolean;
    toBeHiddenCallback?: () => void;
}

export default function QueueHeadDisplay({
                                             children,
                                             itemRotateBySeconds = 5000,
                                             className,
                                             hide = true,
                                             toBeHiddenCallback,
                                         }: QueueHeadDisplayProps) {
    const ref = useRef<HTMLDivElement>(null);

    const [hideState, setHideState] = useState<boolean>(hide);

    const [childIndex, setChildIndex] = useState<number>(0);

    const childrenArray = Children.toArray(children) as any[];

    const closeQueueHeadDisplay = () => {
        setHideState(false);

        toBeHiddenCallback?.();

        setChildIndex(0);
    }

    useEffect(() => {
        setHideState(hide);

        (window as any).toggleQueueHeadDisplay = () => {
            setHideState((previousHideState) => !previousHideState);
        };
    }, [hide]);

    useEffect(() => {
        if (!hideState) return;

        const rotater = setInterval(() => {
            setChildIndex((previousChildIndex): number => {
                return (previousChildIndex + 1) % childrenArray.length;
            });
        }, itemRotateBySeconds * 1000);

        return () => clearInterval(rotater);
    }, [hideState]);

    const next = () => {
        setChildIndex((previousChildIndex): number => {
            return (previousChildIndex + 1) % childrenArray.length;
        });
    };

    const goToNextIfError = (child: ReactElement | ReactElement[] | null): ReactElement | ReactElement[] | null => {
        if (!child) return null;

        if (Array.isArray(child)) {
            return child.map<any>((child: ReactElement | null) => {
                return goToNextIfError(child);
            }).filter(Boolean);
        }

        if (child.type === 'img' || child.type === 'image') {
            child = cloneElement(child, {
                onError: next,
            });
        }

        if (child.type === 'video') {
            child = cloneElement(child, {
                autoPlay: true,
                loop: false,
                onError: next,
                onEnded: () => {
                    console.log('ended');
                    next();
                }
            });
        }

        try {
            return child;
        } catch (error: any) {
            console.error(error);

            next();

            return null;
        }
    };

    return <div ref={ref}
                className={cx("h-[400px] md:h-[500px] lg:h-[600px] w-full relative overflow-hidden", className, {
                    "!h-[0px]": !hideState
                })}>
        <div className="absolute top-0 text-xs bg-primary text-black rounded-br-xl p-1 z-[1000]">Hosted Content</div>
        <Button onClick={closeQueueHeadDisplay}
                className="absolute m-2 top-0 right-0 text-xs bg-gray-700 text-white p-0 z-[1000]">
            <IoClose className="h-6 w-6 text-black"/>
        </Button>
        <div className="relative bg-dark-black w-full h-full z-0 justify-center items-center">
            <div
                className="absolute w-full h-full top-0 left-0 z-[1000] flex justify-center items-center text-black border-[8px] border-dashed border-primary">
                <MediaCenterBox className="max-h-full max-w-full h-full">
                    {
                        goToNextIfError(childrenArray[childIndex])
                        || (
                            <div className="text-lg text-white text-center w-8/12">
                                <h3>Your Gateway to Exclusive Socializing and Visibility!</h3>
                                <br/>
                                <p>Are you ready to take your MyWeed.Club experience to the next level? Get ready to embrace MyWeed.Club Q, your passport to a world of enhanced social interaction, unparalleled visibility, and unmatched fun!</p>
                                <p>🌟 Socialize Beyond Lounge Hours: After the physical lounges close, the party continues on MyWeed.Club Q! Connect with fellow enthusiasts, share your thoughts, and stay engaged with the vibrant cannabis community, anytime, anywhere.</p>
                                <p>🚀 Boost Your Content: Want to make sure your posts are seen by everyone? MyWeed.Club Q catapults your content to front of everyone&apos;s home page and the Q, ensuring that your voice is heard and your posts are in the spotlight.</p>
                                <p>Ready to elevate your MyWeed.Club experience? Join MyWeed.Club Q today and discover a world of endless possibilities and connections. Don&apos;t miss out on the action – be a part of the Q revolution! 🌿💨🎉</p>
                                <p>Get your free account at https://myweed.club, then go to https://myweed.club/q to post your photos, videos and more!</p>
                            </div>
                        )
                    }
                </MediaCenterBox>
            </div>
        </div>
    </div>;
}